var map = {
	"./about-us/goal-mobile.png": "2026",
	"./about-us/goal.png": "4830",
	"./about-us/home-1-mobile.jpg": "c603",
	"./about-us/home-1.jpg": "d2c9",
	"./about-us/home-2-mobile.jpg": "706b",
	"./about-us/home-2.jpg": "820f",
	"./about-us/home-3-mobile.jpg": "e7e4",
	"./about-us/home-3.jpg": "66c5",
	"./about-us/job-mobile.png": "2eb8",
	"./about-us/job.png": "5094",
	"./about-us/process-mobile.png": "8b9d",
	"./about-us/process.png": "305a",
	"./about-us/sketch-about-us-mobile.svg": "9de3",
	"./about-us/sketch-about-us.svg": "759a",
	"./bet-types/sketch-bettype-mobile.svg": "cfdb",
	"./bet-types/sketch-bettype.svg": "5909",
	"./contact/legal.svg": "4b5a",
	"./contact/licensing.svg": "b077",
	"./contact/media.svg": "e8ae",
	"./contact/other-img-mobile.svg": "49c8",
	"./contact/other-img.svg": "4892",
	"./contact/sketch-contact-mobile.svg": "c6ce",
	"./contact/sketch-contact.svg": "f17c",
	"./general/GoalSport_Logo_Final.png": "ba5d",
	"./general/GoalSport_Logo_Final.svg": "5087b",
	"./general/GoalSport_Logo_Final_NoSlogan.png": "0489",
	"./general/GoalSport_Logo_Final_NoSlogan.svg": "c8e8",
	"./general/arrow-down-icon.png": "c663",
	"./general/arrow-down-icon.svg": "05b8",
	"./general/arrow-right-icon.svg": "71c8",
	"./general/close-icon.svg": "873e",
	"./general/general-bg.jpg": "5021",
	"./general/mail-icon-2.svg": "676a",
	"./general/mail-icon.svg": "c6fe",
	"./general/menu-icon.png": "64fb",
	"./header/logo-header-mobile.png": "9f28",
	"./header/logo-header.png": "dd49",
	"./home/chair-banner.jpg": "f57a",
	"./home/chair-banner.webp": "8d18",
	"./home/home-about-bg.png": "195b",
	"./home/light-mobile.svg": "9d0d",
	"./home/light.svg": "66b1",
	"./home/pc-2-mobile.svg": "0988",
	"./home/pc-2.svg": "b740",
	"./home/pc-mobile.svg": "3227",
	"./home/pc.svg": "6c4e",
	"./home/working-banner.jpg": "ef26",
	"./home/working-banner.webp": "b8e2",
	"./products-services/product-event-1-mobile.jpg": "d1b1",
	"./products-services/product-event-1.jpg": "ccf0",
	"./products-services/product-event-2-mobile.jpg": "6917",
	"./products-services/product-event-2.jpg": "6410",
	"./products-services/product-info-mobile.png": "2b20",
	"./products-services/product-info.png": "5b9a",
	"./products-services/product-other-mobile.jpg": "fd38",
	"./products-services/product-other.jpg": "2211",
	"./products-services/sketch-product-mobile.svg": "2f6d",
	"./products-services/sketch-product.svg": "db04",
	"./products-services/sketch-wallet-mobile.svg": "d2cb",
	"./products-services/sketch-wallet.svg": "8afa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";